// Shared design tokens for the "Bento Grid" style introduced in scenes/financial.
// Centralizes the constants that financial/index.jsx hand-rolled per file, so every
// later redesigned page references one source instead of re-hardcoding hex values.

export const FONT = "'Plus Jakarta Sans', 'Noto Sans Lao', system-ui, sans-serif";
export const MONO = "'Space Grotesk', 'Noto Sans Lao', ui-monospace, monospace";

export const CARD_SHADOW = "0 1px 2px rgba(20,18,30,.04),0 16px 32px -24px rgba(20,18,30,.18)";
export const KPI_SHADOW = "0 1px 2px rgba(20,18,30,.04),0 14px 28px -20px rgba(20,18,30,.12)";
export const KPI_SHADOW_PURPLE = "0 1px 2px rgba(20,18,30,.04),0 14px 28px -20px rgba(86,40,160,.22)";
export const WALLET_CARD_SHADOW = "0 1px 2px rgba(20,18,30,.04),0 18px 36px -24px rgba(86,40,160,.3)";

// Purple ramp mirrors theme.palette.secondary — re-exported as plain hex so non-MUI
// contexts (raw sx strings, gradients) don't need useTheme() just for a color.
export const PURPLE_LIGHT = "#7c3aed"; // theme.palette.secondary[500]
export const PURPLE_MAIN = "#6d28d9"; // theme.palette.secondary[600]
export const PURPLE_DARK = "#5b21b6"; // theme.palette.secondary[700]
export const PURPLE_DARKER = "#4c1d95"; // theme.palette.secondary[800]
export const PURPLE_TINT_50 = "#f6f5fb"; // theme.palette.secondary[50]
export const PURPLE_TINT_100 = "#f3f0fc"; // theme.palette.secondary[100]

// Neutral text / background / border tones — not yet in theme.js, centralized here.
export const TEXT_DARK = "#161420";
export const TEXT_BODY = "#2c2937";
export const TEXT_SECONDARY = "#6b6775";
export const TEXT_SUBTLE = "#a8a3b4";

export const BG_WHITE = "#fff";
export const BG_TINT = "#faf9fc";
export const BG_PURPLE_TINT = "#f3f0fc";
export const BG_PURPLE_GRADIENT = "linear-gradient(155deg,#ffffff 0%,#f5efff 100%)";

export const BORDER = "#ece9f1";
export const BORDER_PURPLE = "#ece4fb";
export const DIVIDER = "#f1eff5";

export const SUCCESS_FG = "#15a36a";
export const SUCCESS_BG = "#e7f8ee";
export const ERROR_FG = "#c0343a";
export const ERROR_BG = "#fdeef0";
export const INFO_FG = "#1d4ed8";
export const INFO_BG = "#dbeafe";

export const RADIUS_CARD = "22px";
export const RADIUS_TILE = "18px";
export const RADIUS_INPUT = "13px";
export const RADIUS_PILL = "999px";

export const cardLabelSx = {
  fontSize: "10.5px",
  letterSpacing: ".14em",
  color: TEXT_SUBTLE,
  fontWeight: 700,
  textTransform: "uppercase",
};

export const tableHeaderSx = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: ".1em",
  textTransform: "uppercase",
  color: TEXT_SECONDARY,
};
